import '../../App.css'

import { useEffect } from 'react'
import classnames from 'classnames'
import { AppStore } from '@components/Icons/AppStore'
import { PlayStore } from '@components/Icons/PlayStore'
import { useBankingServicesDisclaimer } from '@hooks/useBankingServicesDisclaimer'
import { useOrgTheme } from '@hooks/useOrgTheme'
import { fireOnboardingLoaded } from '@lib/parentMessageEvents'
import { useWhiteLabelAppDetails } from '@queries/org'
import { useStoreState } from '@store/index'
import { Outlet } from '@tanstack/react-router'

import { AppHeader } from './AppHeader'
import {
  StyledAppBody,
  StyledAppBodyContainer,
  StyledAppFooterContainer,
  StyledAppFooterContent,
  StyledAppLayout,
  StyledFooterAppStoreContainer,
} from './styles'

export const AppLayout = () => {
  const { data: appInfo } = useWhiteLabelAppDetails()
  const embedded = useStoreState(state => state.onboarding.embedded)
  const instanceId = useStoreState(state => state.onboarding.instanceId)
  const bankingServicesDisclaimer = useBankingServicesDisclaimer()
  const theme = useOrgTheme()

  useEffect(() => {
    fireOnboardingLoaded(instanceId)
  }, [instanceId])

  if (embedded) {
    return <Outlet />
  }

  return (
    <StyledAppLayout className={classnames(theme.body, theme.background)}>
      <AppHeader />
      <StyledAppBodyContainer>
        <StyledAppBody className={theme.contentBackground}>
          <Outlet />
        </StyledAppBody>
      </StyledAppBodyContainer>
      <StyledAppFooterContainer className={classnames(theme.footer)}>
        <StyledAppFooterContent>
          <p className="mb-4">
            ©{new Date().getFullYear()} Branch Messenger, Inc.
          </p>
          <StyledFooterAppStoreContainer>
            <a
              href={appInfo?.app_store_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <AppStore />
            </a>
            <a
              href={appInfo?.google_play_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <PlayStore />
            </a>
          </StyledFooterAppStoreContainer>
          <p>{bankingServicesDisclaimer}</p>
        </StyledAppFooterContent>
      </StyledAppFooterContainer>
    </StyledAppLayout>
  )
}
